import React from 'react';

import { FeatureFlagContext } from './FeatureFlagProvider';
import { defaultFeatureFlagsPredicate } from '../SystemSettings/common/utils';

const withFeature = ({ featureKey, featureName, predicate = defaultFeatureFlagsPredicate }) => {
    const getComp = (flagValue, Component, props) => {
        if (flagValue && predicate(flagValue)) {
            props[featureName] = flagValue;
            return <Component {...props} />;
        }
        return <></>;
    };

    return (Component) => (props) => {
        return (
            <FeatureFlagContext.Consumer>
                {(featureFlags) => getComp(featureFlags[featureKey], Component, props)}
            </FeatureFlagContext.Consumer>
        );
    };
};

export default withFeature;
